import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  UrgentBanner,
  UrgentModal,
  readUrgentMessageDismissed,
  writeUrgentMessageDismissed,
} from '@/shared/components/cse'
import { useUrgentBanners } from '@/shared/hooks/useUrgentBanners'

/**
 * Montage des communications urgentes (RV-31) : bandeaux info/warning + modale bloquante
 * pour level=error (DESIGN §7). CookieBanner reste au-dessus dans AppLayout.
 */
export function UrgentMessagesHost() {
  const { t } = useTranslation()
  const messages = useUrgentBanners()
  const [localDismissed, setLocalDismissed] = useState<Record<string, true>>({})

  const bannerMessages = useMemo(() => messages.filter((m) => m.level !== 'error'), [messages])

  const activeError = useMemo(
    () =>
      messages.find(
        (m) =>
          m.level === 'error' && !readUrgentMessageDismissed(m.id) && localDismissed[m.id] !== true,
      ),
    [messages, localDismissed],
  )

  const acknowledgeError = () => {
    if (!activeError) return
    writeUrgentMessageDismissed(activeError.id)
    setLocalDismissed((prev) => ({ ...prev, [activeError.id]: true }))
  }

  return (
    <>
      {bannerMessages.map((banner) => (
        <UrgentBanner
          key={banner.id}
          id={banner.id}
          level={banner.level}
          title={banner.title}
          message={banner.message}
          dismissible={banner.dismissible}
          dismissLabel={t('a11y.dismiss')}
        />
      ))}

      {activeError ? (
        <UrgentModal
          open
          level="error"
          title={activeError.title ?? t('ui.urgent.error_title')}
          message={activeError.message}
          acknowledgeLabel={t('ui.urgent.acknowledge')}
          onAcknowledge={acknowledgeError}
        />
      ) : null}
    </>
  )
}
